<template>
  <div class="mastery-modal-blue">
    <img
      v-if="headerImage"
      class="header-image"
      :class="[headerImageSize]"
      :src="headerImageSrc"
    >
    <div class="title">
      {{ title }}
    </div>
    <div class="content">
      <slot />
    </div>
    <button
      class="primary-action"
      @click="$emit('primary-action-clicked')"
    >
      {{ primaryActionText }}
    </button>
  </div>
</template>

<script>
// Pre-import images using Vite's glob import
const imageModules = import.meta.glob('../../assets/images/*', { eager: true, query: '?url', import: 'default' });
const imageMap = {};
Object.entries(imageModules).forEach(([path, url]) => {
  const filename = path.split('/').pop();
  imageMap[filename] = url;
});

export default {
  props: {
    headerImage: {
      type: [Object, String],
    },
    headerImageSize: {
      type: String,
    },
    primaryActionText: {
      type: String,
    },
    title: {
      type: String,
    },
  },
  emits: ['primary-action-clicked'],
  computed: {
    headerImageSrc() {
      if (typeof this.headerImage === 'string') {
        // is a static file name
        return imageMap[this.headerImage] || '';
      } else {
        // is an attachment object
        return this.headerImage.url;
      }
    },
  },
};
</script>

<style lang="scss">
.mastery-modal-blue {
  background: #001c74;
  color: white;

  .header-image {
    display: block;
    margin: rem-calc(16) auto rem-calc(32) auto;
    width: 60%;

    &.small {
      width: rem-calc(96);
    }
  }

  .title {
    @include charter-font;
    font-size: rem-calc(32);
  }

  .content {
    line-height: 1.5;
    margin: rem-calc(16) 0 rem-calc(48);

    .highlight {
      color: #ffe980;
      font-weight: $bold;
    }
  }

  // We need to capture any generic images in the content that are not the close icon
  img:not(.icon-cross) {
    margin-top: rem-calc(24);
    width: 80%;
  }

  .primary-action {
    background-color: #00d8f8;
    border-radius: 24px;
    color: white;
    font-weight: $semi-bold;
    min-width: rem-calc(170);
    padding: rem-calc(16) rem-calc(24);
  }
}
</style>
